export default __webpack_public_path__ + "static/media/person4.c9fa7159.png";